import { render, staticRenderFns } from "./SmallRowOfferEl.vue?vue&type=template&id=78f87d38&scoped=true&"
import script from "./SmallRowOfferEl.vue?vue&type=script&lang=ts&"
export * from "./SmallRowOfferEl.vue?vue&type=script&lang=ts&"
import style0 from "./SmallRowOfferEl.vue?vue&type=style&index=0&id=78f87d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f87d38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
